import gql from 'graphql-tag';

import {Meta, User, Window} from './fragments';

export const SaveUserMutation = gql`
  mutation saveUser(
    $_id: String
    $email: String!
    $password: String!
    $phone: String!
    $firstName: String!
    $lastName: String!
    $company: String!
    $street: String!
    $city: String!
    $role: String!
    $userStatus: UserStatus!
  ) {
    saveUser(
      _id: $_id
      email: $email
      password: $password
      phone: $phone
      firstName: $firstName
      lastName: $lastName
      company: $company
      street: $street
      city: $city
      role: $role
      userStatus: $userStatus
    ) {
      ...User
    }
  }
  ${User}
`;

export const SaveUserMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    save: user =>
      mutate({
        variables: {_id, ...user},
        updateQueries: {
          allUsers: (
            {allUsers, ...prev},
            {
              mutationResult: {
                data: {saveUser},
              },
            }
          ) =>
            _id
              ? {...prev, allUsers: allUsers.map(user => (user._id === _id ? saveUser : user))}
              : {...prev, allUsers: [saveUser, ...allUsers]},
        },
      }),
  }),
};

export const SaveWindowMutation = gql`
  mutation saveWindow(
    $_id: String
    $name: String
    $winType: String
    $winClass: String
    $variation: String
    $uValueFrame: String
    $uValueGlass: String
    $windLoad: String
    $drivingRain: String
    $psiValue: String
    $rainRackType: String
    $coatingType: String
    $wingSeal: String
    $foldSeal: String
    $glassType: String
    $placeholder: String
    $rainRackProd: String
    $coatingProd: String
    $sealProd: String
    $profileDie: String
    $airPermeable: String
    $operateForce: String
    $mechanicalStress: String
    $thermalInsulation: String
    $soundInsulation: String
    $serialNumber: String
    $qualityReportNumber: String
    $height: String
    $width: String
    $completeSurface: String
  ) {
    saveWindow(
      _id: $_id
      name: $name
      winType: $winType
      winClass: $winClass
      variation: $variation
      uValueFrame: $uValueFrame
      uValueGlass: $uValueGlass
      windLoad: $windLoad
      drivingRain: $drivingRain
      psiValue: $psiValue
      rainRackType: $rainRackType
      coatingType: $coatingType
      wingSeal: $wingSeal
      foldSeal: $foldSeal
      glassType: $glassType
      placeholder: $placeholder
      rainRackProd: $rainRackProd
      coatingProd: $coatingProd
      sealProd: $sealProd
      profileDie: $profileDie
      airPermeable: $airPermeable
      operateForce: $operateForce
      mechanicalStress: $mechanicalStress
      thermalInsulation: $thermalInsulation
      soundInsulation: $soundInsulation
      serialNumber: $serialNumber
      qualityReportNumber: $qualityReportNumber
      height: $height
      width: $width
      completeSurface: $completeSurface
    ) {
      ...Window
    }
  }
  ${Window}
`;

export const SaveWindowMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    save: window =>
      mutate({
        variables: {_id, ...window},
        updateQueries: {
          allWindows: (
            {allWindows, ...prev},
            {
              mutationResult: {
                data: {saveWindow},
              },
            }
          ) =>
            _id
              ? {...prev, allWindows: allWindows.map(win => (win._id === _id ? saveWindow : win))}
              : {...prev, allWindows: [saveWindow, ...allWindows]},
        },
      }),
  }),
};
export const ValidateWindowMutation = gql`
  mutation validateWindow($_id: String!) {
    validateWindow(_id: $_id) {
      ...Window
    }
  }
  ${Window}
`;

export const ValidateWindowMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    validate: window =>
      mutate({
        variables: {_id},
        updateQueries: {
          allWindows: (
            {allWindows, ...prev},
            {
              mutationResult: {
                data: {validateWindow},
              },
            }
          ) => {
            return {...prev, allWindows: allWindows.map(win => (win._id === _id ? validateWindow : win))};
          },
        },
      }),
  }),
};

export const SaveMetaMutation = gql`
  mutation saveMeta($_id: String, $metaType: String!, $value: String!) {
    saveMeta(_id: $_id, metaType: $metaType, value: $value) {
      ...Meta
    }
  }
  ${Meta}
`;

export const SaveMetaMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    save: meta =>
      mutate({
        variables: {_id, ...meta},
        updateQueries: {
          allMeta: (
            {allMetas, ...prev},
            {
              mutationResult: {
                data: {saveMeta},
              },
            }
          ) =>
            _id
              ? {...prev, allMetas: allMetas.map(entry => (entry._id === _id ? saveMeta : entry))}
              : {...prev, allMetas: [saveMeta, ...allMetas]},
        },
      }),
  }),
};

export const ValidateMetaMutation = gql`
  mutation validateMeta($_id: String) {
    validateMeta(_id: $_id) {
      ...Meta
    }
  }
  ${Meta}
`;

export const ValidateMetaMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    validate: meta =>
      mutate({
        variables: {_id, ...meta},
        updateQueries: {
          allMeta: (
            {allMetas, ...prev},
            {
              mutationResult: {
                data: {validateMeta},
              },
            }
          ) =>
            _id
              ? {...prev, allMetas: allMetas.map(entry => (entry._id === _id ? validateMeta : entry))}
              : {...prev, allMetas: [validateMeta, ...allMetas]},
        },
      }),
  }),
};

export const SaveMetaModalMutationConfig = {
  props: ({mutate}) => ({
    save: meta =>
      mutate({
        variables: {...meta},
        updateQueries: {
          allMetas: (
            {allMetas, ...prev},
            {
              mutationResult: {
                data: {saveMeta},
              },
            }
          ) => {
            return {...prev, allMetas: [saveMeta, ...allMetas]};
          },
        },
      }),
  }),
};

export const DeleteMetaMutation = gql`
  mutation deleteMeta($_id: String) {
    deleteMeta(_id: $_id)
  }
`;

export const DeleteMetaMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    delete: meta =>
      mutate({
        variables: {_id},
        updateQueries: {
          allMetas: ({allMetas, ...prev}) => {
            return {...prev, allMetas: allMetas.filter(meta => meta._id !== _id)};
          },
        },
      }),
  }),
};
export const DeleteWindowMutation = gql`
  mutation deleteWindow($_id: String) {
    deleteWindow(_id: $_id)
  }
`;

export const DeleteWindowMutationConfig = {
  props: ({
    mutate,
    ownProps: {
      match: {
        params: {id: _id},
      },
    },
  }) => ({
    delete: window =>
      mutate({
        variables: {_id},
        updateQueries: {
          allWindows: ({allWindows, ...prev}) => {
            return {...prev, allWindows: allWindows.filter(window => window._id !== _id)};
          },
        },
      }),
  }),
};



// WEBPACK FOOTER //
// ./src/qql-shared/mutations.js